import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { SetupSection, Field } from "./BasicsSection";

export const DEFAULT_ALERT = {
  email_subject: "Payment received for {event}",
  email_body: "Dear {name},\n\nWe have received your payment of GHS {amount} ({method}) for {event}.\nReceipt No: {receipt_no}\nTicket No: {ticket_no}\nTotal paid: GHS {total_paid} of GHS {total_due}\nBalance: GHS {balance}\n\nThank you.\nGAMLS Secretariat",
  sms: "Dear {first_name}, we received GHS {amount} for {event}. Receipt {receipt_no}. Balance: GHS {balance}. Thank you. - GAMLS",
};

const TAGS = ["name", "first_name", "amount", "method", "event", "receipt_no", "ticket_no", "total_paid", "total_due", "balance"];

export const PaymentAlertSection = ({ value, onChange }) => {
  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <SetupSection id="payment-alerts" step="07" title="Payment alert messages" description="The email and SMS a member receives each time an Accounts Officer records a payment for this event.">
      <div className="flex flex-wrap gap-1.5 mb-4" data-testid="setup-alert-tags">
        <span className="text-xs text-gray-500 mr-1">Placeholders:</span>
        {TAGS.map((t) => <code key={t} className="text-[11px] bg-[#F8F9FA] border rounded px-1.5 py-0.5">{`{${t}}`}</code>)}
      </div>
      <div className="space-y-4">
        <Field label="Email subject"><Input value={value.email_subject} maxLength={150} onChange={(e) => set({ email_subject: e.target.value })} data-testid="setup-alert-email-subject" /></Field>
        <Field label="Email message"><Textarea rows={9} value={value.email_body} maxLength={3000} onChange={(e) => set({ email_body: e.target.value })} data-testid="setup-alert-email-body" /></Field>
        <Field label={`SMS message (${value.sms.length}/480)`}><Textarea rows={3} value={value.sms} maxLength={480} onChange={(e) => set({ sms: e.target.value })} data-testid="setup-alert-sms" /></Field>
        <button type="button" onClick={() => onChange(DEFAULT_ALERT)} className="text-xs font-semibold text-[#E60000] hover:underline" data-testid="setup-alert-reset">Reset to default wording</button>
      </div>
    </SetupSection>
  );
};
